<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单主体：</span>
        </div>
        <el-input v-model="formData.payer" size="small" style="width: 280px" disabled/>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联账单：</span>
        </div>
        <el-select v-model="payItemDetailListChoose" multiple placeholder="请选择" size="small" style="width: 280px">
          <el-option
            v-for="item in payItemDetailList"
            :key="item.code"
            :label="item._label"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款金额：</span>
        </div>
        <el-input v-model="formData.money" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款方式：</span>
        </div>
        <el-select v-model="formData.payChannel" placeholder="请选择" size="small" style="width: 280px" disabled>
          <el-option v-for="item in payChannelModifyList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款时间：</span>
        </div>
        <el-date-picker v-model="formData.payTime" type="datetime" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" disabled></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>



      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../utils/errorHandler'
import {api} from '../../api/Finance'
import {nError, nSuccess} from '../../../utils/notice'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'deposit-modify',
  data () {
    return {
      breadcrumb: [{
        value: '智慧财务',
        name: 'finance-over-view'
      }, {
        value: '收款管理'
      }],
      mainTitle: '关联账单',
      subheading: '',
      payChannelModifyList: [{
        key: '1',
        label: '微信'
      }, {
        key: '2',
        label: '支付宝'
      }, {
        key: '3',
        label: '银行转账'
      }, {
        key: '4',
        label: '现金'
      }, {
        key: '5',
        label: '其他'
      }],

      invoiceStatusModifyList: [{
        key: '0',
        label: '未开票'
      }, {
        key: '1',
        label: '已开票'
      }],

      enterpriseLoading: false,
      billMainBodyList: [],

      payItemDetailList: [],
      payItemDetailListChoose: [],

      payerCode: '',
      formData: {
        payer: '',
        enterpriseCode: '',
        personCode: '',
        bills: [],
        money: '',
        payChannel: '',
        payTime: '',
        memo: '',
      }
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.getLeasePaymentRecordByCode()
  },
  methods: {
    getLeasePaymentRecordByCode () {
      this.$axios.get(`${api.getReceivePaymentByCode}/${this.currentCode}`, {})
        .then(res => {
          let data = res.data.data
          this.formData = data
          this.getTotalBillList()
        })
        .catch(errorHandler('获取数据失败'))
    },

    toDepositManagement () {
      this.$router.push({
        name: 'contract-pay-record'
      })
    },

    // 获取账单列表
    getTotalBillList () {
      this.$axios.post(`${api.getTotalBillList}`, {
        payer: this.formData.payer,
        status: '0',
      })
        .then(res => {
          let data = res.data.data
          data.map(v => {
            v._label = `${v.feeType}/${v.payDeadline}/${v.payMoney}元`
          })
          data.push({
            code: 'other',
            _label: '其他',
            billNo: 'other'
          })
          this.payItemDetailList = data
        })
        .catch(errorHandler('查询账单失败'))
    },
    confirm () {
      if (this.formData.bills.length === 0) {
        nError('请选择关联账单')
        return
      }
      this.$axios.post(api.linkBillReceivePayment, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('操作成功')
            this.toDepositManagement()
          }
        })
        .catch(errorHandler('操作失败'))
    },
    cancel () {
      this.toDepositManagement()
    }
  },
  watch: {
    payItemDetailListChoose (v) {
      let bills = []
      this.payItemDetailListChoose.map(v => {
        this.payItemDetailList.map(payItem => {
          if (payItem.code === v) {
            let obj = {
              billNo: payItem.code
            }
            bills.push(obj)
          }
        })
      })
      this.formData.bills = bills
    }
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 180px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/InvestmentFinance/recordRelatedBills.vue